import { ChangeEvent } from 'react';
import {Address} from '../types/GrossReceiptReturnTypes'

export function filterMoneyInput(event: ChangeEvent<HTMLInputElement>, allowedDigitsBeforeDecimal: number): string | undefined {
    const newValue = event.target.value;
    // Create a regex that only allows the provided number of digits
    const regexPrefix = /^\d{0,/;
    const regexSuffix = /}(\.\d{0,2})?$/;
    if (newValue.match(regexPrefix.source + allowedDigitsBeforeDecimal + regexSuffix.source)) {
        return newValue;
    }
};

export function filterIntegerInput(event: ChangeEvent<HTMLInputElement>, maxDigits: number): number | null | undefined {
    const newValue = event.target.value;
    // Create a regex that only allows the provided number of digits for integers
    const regex = new RegExp(`^\\d{0,${maxDigits}}$`);
    if (regex.test(newValue)) {
        if (newValue.trim().length === 0) {
            return null;
        }

        return parseInt(newValue);
    }
};

export function addZeroes(num: string): string {

    if (isNaN(Number(num)) || num === "") {
        return "0.00";
    }
    num = num === "." ? "0": num
    const dec = num.split('.')[1]
    const len = dec && dec.length > 2 ? dec.length : 2
    return Number(num).toFixed(len)
}

export function formatAddress(address: Address | undefined): string | undefined {
    if (address === undefined) {
        return 'N/A';
    }
    else {
        const fullAddress = `${address.street} \n ${address.city}, ${address.state} ${address.zipCode}`;
        return fullAddress;
    }
}
